/** SharePoint URL transformations, ported 1:1 from the legacy frontend. */

/** Only *.sharepoint.com URLs can be embedded in the in-app preview iframe — everything
 * else (wiki/help-center citations) gets refused by the target site's frame-ancestors/
 * X-Frame-Options and must open in a new tab instead. */
export function isSharePointUrl(url?: string): boolean {
  return Boolean(url && url.includes("sharepoint.com"))
}

/** Derive a direct-download URL from a SharePoint viewer URL (sourcedoc GUID). */
export function toDownloadUrl(url: string): string {
  if (!url || url === "#") return url
  const guidMatch = url.match(/[?&]sourcedoc=%7B([^%]+)%7D/i) || url.match(/[?&]sourcedoc=\{([^}]+)\}/i)
  const siteMatch = url.match(/^(https:\/\/[^/]+)(\/[^/?]+)/)
  if (guidMatch && siteMatch) {
    const guid = guidMatch[1]
    const origin = siteMatch[1]
    const sitePath = siteMatch[2]
    return `${origin}${sitePath}/_api/web/GetFileById('${guid}')/$value`
  }
  return url
}
